
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/auth";
import { toast } from "sonner";
import AccountGate from "./AccountGate";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !user) {
      toast.error("Du måste vara inloggad för att komma åt denna sida", {
        description: "Du omdirigeras till inloggningssidan"
      });
      const from = `${location.pathname}${location.search}${location.hash}`;
      navigate("/auth", { replace: true, state: { from } });
    }
  }, [user, isLoading, navigate, location.pathname, location.search, location.hash]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-10 w-10 border-t-2 border-b-2 border-primary rounded-full"></div>
      </div>
    );
  }

  return user ? <AccountGate>{children}</AccountGate> : null;
};

export default ProtectedRoute;
